import React, { useState } from 'react';

/* ── Icons ── */
const IcoPhone = () => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 14.2v2.6a1.5 1.5 0 01-1.6 1.5c-2.5-.3-4.9-1.1-7-2.4-2-1.2-3.6-2.8-4.8-4.8-1.3-2.1-2.1-4.5-2.4-7A1.5 1.5 0 013.7 2.6H6.3A1.5 1.5 0 017.8 3.9c.1.9.3 1.7.5 2.5a1.5 1.5 0 01-.4 1.6L6.8 9.1a12 12 0 004.1 4.1l1.1-1.1a1.5 1.5 0 011.6-.4c.8.3 1.6.4 2.5.5a1.5 1.5 0 011.3 1.6z" />
  </svg>
);
const IcoMail = () => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="16" height="12" rx="1" />
    <path d="M2 5l8 6 8-6" />
  </svg>
);
const IcoPin = () => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 18c-3.5-4.5-6-7.5-6-11a6 6 0 1112 0c0 3.5-2.5 6.5-6 11z" />
    <circle cx="10" cy="7" r="2" />
  </svg>
);
const IcoClock = () => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="10" cy="10" r="7.5" />
    <path d="M10 5.5V10l3 2" />
  </svg>
);
const IcoLinkedIn = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.22 8h4.56v14H.22V8zm7.8 0h4.37v1.9h.06c.61-1.15 2.1-2.36 4.33-2.36 4.62 0 5.48 3.04 5.48 7v8.46h-4.57v-7.5c0-1.79-.03-4.1-2.5-4.1-2.5 0-2.88 1.95-2.88 3.96V22H8.02V8z" />
  </svg>
);
const IcoFacebook = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 5 3.66 9.13 8.44 9.88V14.9H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.9h-2.33v6.98C18.34 21.13 22 17 22 12z" />
  </svg>
);
const IcoTwitter = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.9 1.9h3.7L14.5 11l9.5 12.6h-7.5l-5.8-7.7-6.7 7.7H.3l8.7-10L0 1.9h7.7l5.3 7 6-7zm-1.3 19.5h2.1L6.5 4H4.3l13.3 17.4z" />
  </svg>
);

/* ── Data ── */
const contactInfo = [
  { Icon: IcoPhone, label: 'Téléphone', value: '+222 34 72 48 48', sub: '+222 30 70 00 06' },
  { Icon: IcoMail, label: 'Email', value: 'contact@miid.mr', sub: 'Réponse sous 24h' },
  { Icon: IcoPin, label: 'Adresse', value: 'Nouakchott, Mauritanie' },
  { Icon: IcoClock, label: 'Horaires', value: 'Lundi — Vendredi · 9h — 18h' },
];

const socials = [
  { name: 'LinkedIn', Icon: IcoLinkedIn, url: '/#' },
  { name: 'Facebook', Icon: IcoFacebook, url: '/#' },
  { name: 'Twitter', Icon: IcoTwitter, url: '/#' },
];

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-accent-top" />

      <div className="contact-inner">
        {/* Header */}
        <div className="reveal contact-header">
          <div className="sec-tag" style={{ color: 'rgba(255,255,255,.55)' }}>
            Parlons-en
          </div>
          <h2 className="contact-title">
            Démarrons votre <em>projet</em>
          </h2>
          <div className="contact-bar" />
          <p className="contact-lead">
            Décrivez votre besoin par message, ou planifiez un appel découverte de 30 min.
          </p>
        </div>

        <div className="contact-grid">
          {/* Left: info + calendly */}
          <div className="reveal">
            <h3 className="contact-block-title">Informations</h3>

            <div className="contact-info-list">
              {contactInfo.map((info) => (
                <div key={info.label} className="contact-info-item">
                  <div className="contact-info-icon"><info.Icon /></div>
                  <div>
                    <div className="contact-info-label">{info.label}</div>
                    <div className="contact-info-value">{info.value}</div>
                    {info.sub && <div className="contact-info-sub">{info.sub}</div>}
                  </div>
                </div>
              ))}
            </div>

            {/* Calendly CTA block */}
            <div className="contact-calendly">
              <div className="contact-calendly-head">
                <div className="contact-calendly-icon">
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="16" height="15" rx="1.5" />
                    <path d="M2 7h16M7 1v4M13 1v4" />
                  </svg>
                </div>
                <div>
                  <div className="contact-calendly-label">Alternative rapide</div>
                  <div className="contact-calendly-title">Planifier un appel de 30 min</div>
                </div>
              </div>
              <p className="contact-calendly-desc">
                Présentez-nous votre projet en direct. On vous recontacte avec une première proposition sous 48h.
              </p>
              <a href="https://calendly.com/miid" target="_blank" rel="noopener noreferrer" className="contact-calendly-btn">
                Réserver un créneau
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                  <path d="M1 7h12M7 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>

            {/* Socials */}
            <div className="contact-socials">
              <div className="contact-socials-label">Suivez-nous</div>
              <div className="contact-socials-list">
                {socials.map((s) => (
                  <a key={s.name} href={s.url} className="contact-social" aria-label={s.name}>
                    <s.Icon />
                    <span>{s.name}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right: form */}
          <div className="reveal d2">
            <h3 className="contact-block-title">Envoyez un message</h3>

            {submitted && (
              <div className="contact-success">
                ✓ Message envoyé. Nous vous répondons sous 24h.
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              {[
                { id: 'name', label: 'Nom complet', type: 'text', placeholder: 'Votre nom' },
                { id: 'email', label: 'Email', type: 'email', placeholder: 'votre@email.com' },
                { id: 'subject', label: 'Sujet', type: 'text', placeholder: 'Objet de votre message' },
              ].map((field) => (
                <div key={field.id} className="contact-field">
                  <label htmlFor={field.id} className="contact-label">{field.label}</label>
                  <input
                    id={field.id}
                    type={field.type}
                    name={field.id}
                    value={(formData as any)[field.id]}
                    onChange={handleChange}
                    required
                    placeholder={field.placeholder}
                    className="contact-input"
                  />
                </div>
              ))}

              <div className="contact-field">
                <label htmlFor="message" className="contact-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  placeholder="Décrivez votre projet, vos enjeux, votre stack actuelle…"
                  className="contact-input contact-textarea"
                />
              </div>

              <button type="submit" className="btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                Envoyer le message
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M1 7h12M7 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      </div>

      <style>{`
        .contact-section {
          padding: 6rem 0;
          background: var(--black);
          position: relative;
          overflow: hidden;
        }
        .contact-accent-top {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(184,146,42,.6), transparent);
        }
        .contact-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }
        .contact-header {
          text-align: center;
          margin-bottom: 3.5rem;
        }
        .contact-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(2rem, 4vw, 2.8rem);
          font-weight: 600;
          color: #FFFFFF;
          line-height: 1.2;
          margin: 0 0 .5rem;
        }
        .contact-title em {
          font-style: italic;
          color: var(--gold);
        }
        .contact-bar {
          width: 48px;
          height: 3px;
          background: var(--gold);
          margin: 1rem auto;
        }
        .contact-lead {
          font-family: 'Montserrat', sans-serif;
          font-size: .88rem;
          font-weight: 300;
          color: rgba(255,255,255,.55);
          max-width: 500px;
          margin: 0 auto;
          line-height: 1.8;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1.15fr;
          gap: 3rem;
          align-items: start;
        }
        .contact-block-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 1.4rem;
          font-weight: 600;
          color: #FFFFFF;
          margin: 0 0 1.5rem;
        }
        .contact-info-list {
          display: flex;
          flex-direction: column;
          gap: 1.2rem;
          margin-bottom: 2rem;
        }
        .contact-info-item {
          display: flex;
          gap: 1rem;
          align-items: flex-start;
        }
        .contact-info-icon {
          width: 36px;
          height: 36px;
          border: 1px solid rgba(184,146,42,.35);
          background: rgba(184,146,42,.08);
          color: var(--gold);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .contact-info-label {
          font-family: 'Montserrat', sans-serif;
          font-size: .55rem;
          font-weight: 700;
          letter-spacing: .2em;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: .3rem;
        }
        .contact-info-value {
          font-family: 'Montserrat', sans-serif;
          font-size: .88rem;
          font-weight: 500;
          color: #FFFFFF;
        }
        .contact-info-sub {
          font-family: 'Montserrat', sans-serif;
          font-size: .7rem;
          color: rgba(255,255,255,.45);
          margin-top: .15rem;
        }

        /* Calendly block */
        .contact-calendly {
          margin-top: 1rem;
          padding: 1.3rem 1.4rem;
          background: rgba(184,146,42,.06);
          border: 1px solid rgba(184,146,42,.25);
          position: relative;
          overflow: hidden;
        }
        .contact-calendly::before {
          content: '';
          position: absolute;
          top: -30px;
          right: -30px;
          width: 80px;
          height: 80px;
          background: radial-gradient(circle, rgba(184,146,42,.25), transparent 70%);
          pointer-events: none;
        }
        .contact-calendly-head {
          display: flex;
          gap: .9rem;
          align-items: center;
          margin-bottom: .8rem;
        }
        .contact-calendly-icon {
          width: 36px;
          height: 36px;
          color: var(--gold);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .contact-calendly-label {
          font-family: 'Montserrat', sans-serif;
          font-size: .5rem;
          font-weight: 700;
          letter-spacing: .2em;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: .2rem;
        }
        .contact-calendly-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 1.15rem;
          font-weight: 600;
          color: #FFFFFF;
        }
        .contact-calendly-desc {
          font-family: 'Montserrat', sans-serif;
          font-size: .75rem;
          font-weight: 300;
          color: rgba(255,255,255,.55);
          line-height: 1.7;
          margin: 0 0 1rem;
        }
        .contact-calendly-btn {
          display: inline-flex;
          align-items: center;
          gap: .5rem;
          background: var(--gold);
          color: var(--black);
          padding: .6rem 1.1rem;
          font-family: 'Montserrat', sans-serif;
          font-size: .65rem;
          font-weight: 700;
          letter-spacing: .14em;
          text-transform: uppercase;
          text-decoration: none;
          transition: background .2s ease;
        }
        .contact-calendly-btn:hover {
          background: var(--gold-light);
        }

        /* Socials */
        .contact-socials { margin-top: 2rem; }
        .contact-socials-label {
          font-family: 'Montserrat', sans-serif;
          font-size: .55rem;
          font-weight: 700;
          letter-spacing: .2em;
          text-transform: uppercase;
          color: rgba(255,255,255,.45);
          margin-bottom: .7rem;
        }
        .contact-socials-list {
          display: flex;
          gap: .5rem;
          flex-wrap: wrap;
        }
        .contact-social {
          display: inline-flex;
          align-items: center;
          gap: .5rem;
          padding: .5rem .9rem;
          border: 1px solid rgba(255,255,255,.15);
          background: rgba(255,255,255,.03);
          color: rgba(255,255,255,.7);
          font-family: 'Montserrat', sans-serif;
          font-size: .65rem;
          font-weight: 500;
          letter-spacing: .05em;
          text-decoration: none;
          transition: all .2s ease;
        }
        .contact-social:hover {
          border-color: var(--blue);
          color: var(--blue-light);
          background: rgba(26,111,168,.08);
        }

        /* Form */
        .contact-success {
          background: rgba(46,125,50,.15);
          border: 1px solid rgba(46,125,50,.4);
          padding: .9rem 1.1rem;
          margin-bottom: 1.3rem;
          font-family: 'Montserrat', sans-serif;
          font-size: .8rem;
          color: #82D091;
        }
        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        .contact-field {}
        .contact-label {
          display: block;
          font-family: 'Montserrat', sans-serif;
          font-size: .58rem;
          font-weight: 700;
          letter-spacing: .16em;
          text-transform: uppercase;
          color: rgba(255,255,255,.55);
          margin-bottom: .45rem;
        }
        .contact-input {
          width: 100%;
          padding: .8rem 1rem;
          background: rgba(255,255,255,.04);
          border: 1px solid rgba(255,255,255,.12);
          color: #FFFFFF;
          font-family: 'Montserrat', sans-serif;
          font-size: .85rem;
          outline: none;
          transition: border-color .2s;
          border-radius: 0;
        }
        .contact-input:focus { border-color: var(--blue-light); }
        .contact-input::placeholder { color: rgba(255,255,255,.3); }
        .contact-textarea { resize: vertical; }

        /* Responsive */
        @media (max-width: 900px) {
          .contact-grid { grid-template-columns: 1fr; gap: 3rem; }
        }
        @media (max-width: 520px) {
          .contact-section { padding: 4rem 0; }
          .contact-inner { padding: 0 1rem; }
          .contact-header { margin-bottom: 2.5rem; }
          .contact-grid { gap: 2.5rem; }
        }
      `}</style>
    </section>
  );
};

export default Contact;
